module.exports = __webpack_public_path__ + "media/img/logos/2024/tag_des_wissens-e44ae3bd267379429923a7e64ce42c1a.svg";